import * as React from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';

const MAX_RECENT_SEARCHES = 5;

/**
 * Atom to store the recent searches done by the user using AI Search / Lens.
 */
const recentAISearchesAtom = atom<string[]>({
    key: 'recentAISearches',
    default: [],
    effects: [localStorage.recoilEffect('@recoil/recentAISearches', [])],
});

/**
 * List the recent searches done using AI Search / Lens.
 */
export function useRecentAISearches(): string[] {
    return useRecoilValue(recentAISearchesAtom);
}

/**
 * Add a new search to the recent searches.
 */
export function useRegisterRecentAISearch(query: string) {
    const setRecentSearches = useSetRecoilState(recentAISearchesAtom);

    React.useEffect(() => {
        if (!query) {
            return;
        }

        setRecentSearches((recentSearches) => {
            if (recentSearches.includes(query)) {
                return recentSearches;
            }

            return [query, ...recentSearches.slice(0, MAX_RECENT_SEARCHES - 1)];
        });
    }, [query]);
}
